import { FormControlLabel, Radio, RadioGroup } from '@mui/material'
import { BaseGridLayout, BaseScatola } from '@lucan/base-ui'
import { DATICONDUCENTE_VERBALE_DECURTAZIONE } from 'configuration/datiConducente'
import LineaSeparatrice from 'components/ui/LineaSeparatrice'
import MessaggioEvidenziato from 'components/ui/MessaggioEvidenziato'
import Sezione from 'components/ui/Sezione'
import ScatolettaDownloadAllegato from 'components/ui/ScatolettaDownloadAllegato'
import Sottotitolo from 'components/ui/Sottotitolo'
import Testo from 'components/ui/Testo'
import Titoletto from 'components/ui/Titoletto'
import { CFG_MODALITA_INVIO_DATI_CONDUCENTE } from '../utilDatiConducente'

const CFG = DATICONDUCENTE_VERBALE_DECURTAZIONE

export default function DecurtazionePuntiInvioModulo(props) {
  const {
    val, txt,
    chiaveVerbale,
    moduloBin,
    modalitaInvio,
    setModalitaInvio,
    modalitaInvioAbilitate,
  } = props

  return (
    <Sezione
      titolo={val(CFG.INVIO_MODULO_TITOLO)}
      sottotitolo={val(CFG.INVIO_MODULO_SOTTOTITOLO)}
    >
      <BaseGridLayout vertical sx={{ mt: 0 }}>
        <MessaggioEvidenziato error titolo={val(CFG.INSERISCI_DATI_AVVISO_PROCEDURA_INCOMPLETA_TITOLO)}>
          {txt(CFG.INSERISCI_DATI_AVVISO_PROCEDURA_INCOMPLETA_DESCR)}
        </MessaggioEvidenziato>

        <BaseScatola outlined>
          <Titoletto variant='h5'>{txt(CFG.INVIO_MODULO_SCARICA_MODULO_TITOLO)}</Titoletto>
          <Sottotitolo>{txt(CFG.INVIO_MODULO_SCARICA_MODULO_SOTTOTITOLO)}</Sottotitolo>
          <ScatolettaDownloadAllegato
            allegato={{ id: moduloBin, nome: val(CFG.INVIO_MODULO_SCARICA_MODULO_NOME_FILE) }}
            chiavePerUuid={chiaveVerbale}
            sx={{ width: 'fit-content', mt: 2 }}
          />
        </BaseScatola>

        <BaseScatola outlined>
          <Titoletto variant='h5'>{txt(CFG.INVIO_MODULO_FIRMA_MODULO_TITOLO)}</Titoletto>
          <Sottotitolo>{txt(CFG.INVIO_MODULO_FIRMA_MODULO_SOTTOTITOLO)}</Sottotitolo>
        </BaseScatola>

        <BaseScatola outlined>
          <Titoletto variant='h5'>{txt(CFG.INVIO_MODULO_MODALITA_TITOLO)}</Titoletto>
          <RadioGroup
            value={modalitaInvio}
            onChange={e => setModalitaInvio(e.target.value)}
          >
            {modalitaInvioAbilitate.map((modalita, index, array) => {
              const { cfgTitolo, cfgSottotitolo } = CFG_MODALITA_INVIO_DATI_CONDUCENTE[modalita]
              return (
                <div key={modalita}>
                  <FormControlLabel
                    value={modalita}
                    control={<Radio />}
                    label={
                      <>
                        <Testo grassetto>{txt(cfgTitolo)}</Testo>
                        <Sottotitolo>{txt(cfgSottotitolo)}</Sottotitolo>
                      </>
                    }
                  />
                  {index !== array.length - 1 && <LineaSeparatrice />}
                </div>
              )
            })}
          </RadioGroup>
        </BaseScatola>
      </BaseGridLayout>
    </Sezione>
  )
}